import { Leaderboard } from '@mui/icons-material';
import { Box, Card, CardContent, CssBaseline, Grid, Typography } from '@mui/material';
import { ArcElement, BarElement, CategoryScale, Chart, Legend, LinearScale, LineElement, PointElement, Title, Tooltip } from 'chart.js';
import React from 'react'
import { Bar, Doughnut, Line } from 'react-chartjs-2';
import MyBreadcrumbs from '../../../components/MyBreadcrumbs';

Chart.register(
    CategoryScale,
    LinearScale,
    PointElement,
    LineElement,
    Title,
    Tooltip,
    Legend,
    BarElement,
    ArcElement
);

const breadcrumbItem = { '/admin': 'Home' };

export const optionsChartLine = {
    responsive: true,
    plugins: {
        legend: {
            position: 'top',
        },
        title: {
            display: true,
            text: 'Progres Realisasi Keuangan',
        },
    },
};

export const dataChartLine = {
    labels: ['Januari', 'Februari', 'Maret', 'April', 'Mei', 'Juni', 'Juli', 'Agustus', 'September', 'Oktober', 'November', 'Desember'],
    datasets: [
        {
            label: 'Progres',
            data: [0, 20, 24, 60, 80, 120, 137],
            borderColor: 'rgb(255, 99, 132)',
            backgroundColor: 'rgba(255, 99, 132, 0.5)',
            cubicInterpolationMode: 'monotone',
        },
        // {
        //     label: 'Dataset 2',
        //     data: [20, 35, 60, 80, 120, 160, 180],
        //     borderColor: 'rgb(53, 162, 235)',
        //     backgroundColor: 'rgba(53, 162, 235, 0.5)',
        //     cubicInterpolationMode: 'monotone',
        // },
    ],
};

export const optionsChartBar = {
    responsive: true,
    plugins: {
        legend: {
            position: 'top',
        },
        title: {
            display: true,
            text: 'Realisasi Keuangan Perbulan',
        }
    },
    scales: {
        x: {
            stacked: true,
        },
        y: {
            stacked: true
        }
    }
};

export const dataChartBar = {
    labels: ['Januari', 'Februari', 'Maret', 'April', 'Mei', 'Juni', 'Juli', 'Agustus', 'September', 'Oktober', 'November', 'Desember'],
    datasets: [
        {
            label: 'LS',
            data: [40, 60, 50, 60, 55, 70, 57],
            backgroundColor: 'rgba(255, 99, 132, 0.5)',
        },
        {
            label: 'UP',
            data: [60, 50, 60, 55, 70, 57, 80],
            backgroundColor: 'rgba(53, 162, 235, 0.5)',
        },
    ],
};

export const optionsChartDoughnut = {
    responsive: true,
    plugins: {
        legend: {
            position: 'top',
        },
        title: {
            display: true,
            text: 'Presentase SPM',
        },
    },
};

export const dataDoughnut = {
    labels: ['LS', 'UP', 'GU', 'TU'],
    datasets: [
        {
            label: '# of Votes',
            data: [12, 19, 3, 5],
            backgroundColor: [
                'rgba(255, 99, 132, 0.2)',
                'rgba(54, 162, 235, 0.2)',
                'rgba(255, 206, 86, 0.2)',
                'rgba(75, 192, 192, 0.2)',
            ],
            borderColor: [
                'rgba(255, 99, 132, 1)',
                'rgba(54, 162, 235, 1)',
                'rgba(255, 206, 86, 1)',
                'rgba(75, 192, 192, 1)',
            ],
            borderWidth: 1,
        },
    ],
    // options: {
    //     responsive: true,
    //     plugins: {
    //         legend: {
    //             position: 'top',
    //         },
    //         title: {
    //             display: true,
    //             text: 'Realisasi Keuangan Perbulan',
    //         },
    //     },
    //     scales: {
    //         x: {
    //             stacked: true,
    //         },
    //         y: {
    //             stacked: true
    //         }
    //     }
    // }
};

const Home = () => {

    return (
        <>
            <CssBaseline />
            <MyBreadcrumbs breadcrumbItem={breadcrumbItem} title="Admin" />
            <Grid container spacing={2} direction="row" sx={{ p: 2 }}>
                <Grid item xs={12} sm={4} md={3} >
                    <Card sx={{ bgcolor: 'info.main', color: 'info.contrastText', position: 'relative' }}>
                        <Box sx={{ position: 'absolute', width: '100%', height: '100%', backgroundColor: 'ff0000', textAlign: 'right' }} py={2}>
                            <Leaderboard sx={{ width: 'auto', height: '100%', opacity: '20%' }} />
                        </Box>
                        <CardContent>
                            <Typography sx={{ fontSize: 14, fontWeight: 500 }} gutterBottom>
                                Total SPM
                            </Typography>
                            <Typography variant="h3" component="div" sx={{ fontWeight: 600 }}>
                                623
                            </Typography>
                            <Typography variant="body1" component="div" sx={{ fontWeight: 500 }}>
                                Rp. 945.235.246
                            </Typography>
                        </CardContent>
                    </Card>
                </Grid>
                <Grid item xs={12} sm={8} md={9} >
                    <Grid container spacing={2} direction="row" >
                        <Grid item xs={3}>
                            <Card sx={{ position: 'relative', color: 'primary.main' }} variant="outlined">
                                <Box sx={{ position: 'absolute', width: '100%', height: '100%', backgroundColor: 'ff0000', textAlign: 'right' }} py={2}>
                                    <Leaderboard sx={{ width: 'auto', height: '100%', opacity: '20%' }} color="primary" />
                                </Box>
                                <CardContent>
                                    <Typography sx={{ fontSize: 14, fontWeight: 500 }} gutterBottom>
                                        <b>LS</b>
                                    </Typography>
                                    <Typography variant="h3" component="div" sx={{ fontWeight: 600 }}>
                                        365
                                    </Typography>
                                    <Typography variant="body1" component="div" sx={{ fontWeight: 500 }}>
                                        Rp. 85.235.246
                                    </Typography>
                                </CardContent>
                            </Card>
                        </Grid>
                        <Grid item xs={3}>
                            <Card sx={{ position: 'relative', color: 'success.main' }} variant="outlined" >
                                <Box sx={{ position: 'absolute', width: '100%', height: '100%', backgroundColor: 'ff0000', textAlign: 'right' }} py={2}>
                                    <Leaderboard sx={{ width: 'auto', height: '100%', opacity: '20%' }} color="success" />
                                </Box>
                                <CardContent>
                                    <Typography sx={{ fontSize: 14, fontWeight: 500 }} gutterBottom>
                                        <b>UP</b>
                                    </Typography>
                                    <Typography variant="h3" component="div" sx={{ fontWeight: 600 }}>
                                        117
                                    </Typography>
                                    <Typography variant="body1" component="div" sx={{ fontWeight: 500 }}>
                                        Rp. 34.235.246
                                    </Typography>
                                </CardContent>
                            </Card>
                        </Grid>
                        <Grid item xs={3}>
                            <Card sx={{ position: 'relative', color: 'warning.main' }} variant="outlined">
                                <Box sx={{ position: 'absolute', width: '100%', height: '100%', backgroundColor: 'ff0000', textAlign: 'right' }} py={2}>
                                    <Leaderboard sx={{ width: 'auto', height: '100%', opacity: '20%' }} color="warning" />
                                </Box>
                                <CardContent>
                                    <Typography sx={{ fontSize: 14, fontWeight: 500 }} gutterBottom>
                                        <b>TU</b>
                                    </Typography>
                                    <Typography variant="h3" component="div" sx={{ fontWeight: 600 }}>
                                        97
                                    </Typography>
                                    <Typography variant="body1" component="div" sx={{ fontWeight: 500 }}>
                                        Rp. 25.235.246
                                    </Typography>
                                </CardContent>
                            </Card>
                        </Grid>
                        <Grid item xs={3}>
                            <Card sx={{ position: 'relative', color: 'error.main' }} variant="outlined">
                                <Box sx={{ position: 'absolute', width: '100%', height: '100%', backgroundColor: 'ff0000', textAlign: 'right' }} py={2}>
                                    <Leaderboard sx={{ width: 'auto', height: '100%', opacity: '20%' }} color="error" />
                                </Box>
                                <CardContent>
                                    <Typography sx={{ fontSize: 14, fontWeight: 500 }} gutterBottom>
                                        <b>GU</b>
                                    </Typography>
                                    <Typography variant="h3" component="div" sx={{ fontWeight: 600 }}>
                                        143
                                    </Typography>
                                    <Typography variant="body1" component="div" sx={{ fontWeight: 500 }}>
                                        Rp. 45.235.246
                                    </Typography>
                                </CardContent>
                            </Card>
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
            <Grid container spacing={2} direction="row" sx={{ p: 2 }}>
                <Grid item xs={12} lg={8}>
                    <Card variant='outlined'>
                        <CardContent>
                            <Line options={optionsChartLine} data={dataChartLine} />
                        </CardContent>
                    </Card>
                </Grid>
                <Grid item xs={12} lg={4}>
                    <Card variant='outlined' sx={{ height: '100%' }} >
                        <Doughnut options={optionsChartDoughnut} data={dataDoughnut} />
                    </Card>
                </Grid>
            </Grid>
            <Grid container spacing={2} direction="row" sx={{ p: 2 }}>
                <Grid item xs={12} lg={4}>
                    <Card variant='outlined' sx={{ height: '100%' }}>
                        <CardContent>
                            <Line options={optionsChartLine} data={dataChartLine} />
                        </CardContent>
                    </Card>
                </Grid>
                <Grid item xs={12} lg={8}>
                    <Card variant='outlined'>
                        <Bar options={optionsChartBar} data={dataChartBar} />
                    </Card>
                </Grid>
            </Grid>
        </>
    )
}

export default Home